export enum ProjectTranslationTabEnumUi {
  TRANSLATIONS = 'TRANSLATIONS',
  TRANSLATION_FORM = 'TRANSLATION_FORM',
  LABELS_SETTINGS = 'LABELS_SETTINGS',
}
